//frontend/src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { BookingProvider } from './context/BookingContext';
import { SocketProvider } from './context/SocketContext';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 <React.StrictMode>
   <BrowserRouter>
     <I18nextProvider i18n={i18n}>
       <LocalizationProvider dateAdapter={AdapterDateFns}>
         <SocketProvider>
           <BookingProvider>
             <App />
           </BookingProvider>
         </SocketProvider>
       </LocalizationProvider>
     </I18nextProvider>
   </BrowserRouter>
 </React.StrictMode>
);